import {
    actionWithLoader,
    getReplacingPath,
    haveAccessRight,
    onEnter,
    push
} from "../../Utils/utils"
import {
    getPlanningReportRules,
    savePlanningRuleBrand,
    savePlanningRuleEnterprise
} from "../../../parseManager/planning/parsePlanningManager"
import { getPlanningSettingsReportRulesSelector } from "../../../reducers/Planning/PlanningSettings"

export function updateReportRules(values) {
    return actionWithLoader(async (dispatch, getState) => {
        try {
            const currentRules = getPlanningSettingsReportRulesSelector(getState()) || {}
            for (const [entityKey, formValues] of Object.entries(values)) {
                const isEnterprise = !!(currentRules[entityKey] && currentRules[entityKey]._isEnterprise)
                if (isEnterprise) {
                    await savePlanningRuleEnterprise(entityKey, formValues)
                } else {
                    await savePlanningRuleBrand(entityKey, formValues)
                }
            }
            const reportRules = await getPlanningReportRules(true)
            dispatch({
                type: "PLANNING_SETTINGS_REPORT_RULES_UPDATED",
                planningSettingsSnackBar: {
                    open: true,
                    type: "success",
                    message: "Les régles de report ont été sauvegardées",
                    duration: 5000
                },
                reportRules
            })
        } catch(err) {
            dispatch({
                type: "PLANNING_SETTINGS_SNACKBAR",
                planningSettingsSnackBar: {
                    open: true,
                    type: "error",
                    message: "Les régles de report n'ont pas pu être sauvegardés",
                    duration: 5000
                }
            })
        }
    })
}

export function loadPlanningSettingReport() {
    return actionWithLoader(async (dispatch) => {
        // getPlanningReportRules always returns {brand: json}
        const reportRules = await getPlanningReportRules(true)
        dispatch({
            type: "PLANNING_SETTINGS_REPORT_RULES_LOADED",
            reportRules,
        })
    })
}

export function onEnterPlanningSettingReport(store) {
    return onEnter({
        store,
        actionThunk: loadPlanningSettingReport,
        getReplacingPath: getReplacingPath({needUser: true}),
        haveAccessRight: haveAccessRight({readPlanningRules: true})
    })
}

export function showPlanningSettingReport() {
    return push("/settings/production/reports")
}
